import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { SrmLayout } from 'containers/srm/srmLayoutContainer/SrmLayout';
import ConnectedPrivateRoute from 'hoc/PrivateRoute';
import { useMicrosoftAuth } from '../hooks/useMicrosoftAuth';
import { selectIsAuthenticated } from 'store/microsoftGraph/Selector';
import { setIsAuthenticated } from 'store/microsoftGraph/ActionCreator';
import { fetchCurrentUserRoles } from 'store/authorization/ActionCreator';

export const SrmLayoutRoute = ({ component: Component, toolbar: Toolbar, ...props }) => {
  const { setActiveAccount } = useMicrosoftAuth();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    setActiveAccount();
    if (localStorage.getItem('user')) {
      dispatch(fetchCurrentUserRoles());
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated && localStorage.getItem('user')) {
      dispatch(setIsAuthenticated(true));
    }
  }, [isAuthenticated, dispatch]);

  return (
    <ConnectedPrivateRoute
      {...props}
      render={componentProps => (
        <SrmLayout toolbar={Toolbar ? <Toolbar /> : null}>
          <Component {...componentProps} />
        </SrmLayout>
      )}
    />
  );
};

SrmLayoutRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.shape(),
  ]),
  toolbar: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.shape(),
  ]),
};
